module.exports = __webpack_public_path__ + "static/cover-2d65259054a95d29e3af607f9522a2ee.jpg";